import React, { useMemo } from 'react'
import styled from 'styled-components'
import { match } from 'ts-pattern'

import KOL_MARK from '@root/shared/assets/brand/kol-mark.png'

import { Platform } from '../../model'

import D_FUN_CIRCLE_LOGO from './assets/d-fun-circle-logo.inline.png'
import D_NFT_CIRCLE_LOGO from './assets/d-nft-circle-logo.inline.png'

import type { ClassNameProps } from '@root/shared/react'

type PlatformCircleIconProps = {
  platform: Platform.Platform
  size: number
} & ClassNameProps

export const PlatformCircleIcon: React.FC<PlatformCircleIconProps> = ({
  className,
  platform,
  size,
}) => {
  const logoSrc = useMemo(() => {
    return match(platform)
      .with(Platform.Pump, () => D_FUN_CIRCLE_LOGO)
      .with(Platform.NFT, () => D_NFT_CIRCLE_LOGO)
      .with(Platform.Terminal, () => KOL_MARK)
      .with(Platform.Premium, () => KOL_MARK)
      .otherwise(() => undefined)
  }, [platform])

  return (
    <Root
      src={logoSrc}
      className={className}
      style={{
        width: size,
        height: size,
      }}
    />
  )
}

const Root = styled.img`
  border-radius: 50%;
  object-fit: cover;
`
